<div class="modal-container" data-uit="modal-container">
    <div class="modal-top">
        <h2 *ngIf="showTitle && modalTitle" [ngClass]="{ 'text-center': isTitleCentered, 'ms-4': hasFullwidthButton }" class="text-truncate">
            {{ modalTitle }}
        </h2>
        <p *ngIf="showDescription && description" class="mt-1" [innerHtml]="description"></p>
        <span></span>
        <ng-content select="[header]"></ng-content>
    </div>
    <div class="modal-body py-0" [ngClass]="{ 'text-center': isBodyCentered }">
        <ng-content></ng-content>
    </div>
    <button
        type="button"
        *ngIf="showClose"
        class="btn ca-btn-icon ca-btn-icon-big modal-button-close"
        (click)="dismiss.emit('Canceled')"
        data-uit="close-modal"
        [title]="'GENERAL.CLOSE' | translate"
    >
        <ca-icon name="cross" size="l"></ca-icon>
    </button>
</div>
